// extracted by mini-css-extract-plugin
export default {"container":"CreateIssueFooter-module__container--QNodp","Checkbox":"CreateIssueFooter-module__Checkbox--l4pYZ"};